import { getList, publicPage, settlementBillListOptions } from './geSettlementBillList'
import { deepClone } from '@/assets/js/utils'
import { confirmSettlePaid } from '@/api/wenjuan/settlement'
import GlobalConfig from '@/global/config'

export default {
  props: {
    searchField: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      surveyId: '',
      settleType: 0,
      forms: {
        type: '1', //结算状态
        dates1: '', // 奖励产生时间
        answerChannel: '', // 子渠道
        answerId: '', // 答卷样本id
        sendStatus: '' // 发放状态 0失败 1成功 2等待
      },
      option: settlementBillListOptions,
      page: publicPage,
      sentData: {},
      diaBillTitle: {
        cancel: '撤销结算单确认',
        start: '发起结算单确认',
        payOffline: '线下支付确认'
      },
      dialogSettlementBillTitle: '生成结算单确认',
      dialogSettlementBillVisible: false,
      dialogUnitPrice: '',
      dialogType: '',
      dialogTypeSub: '',
      sheetNum: 0,
      sheetAmountSum: 0,
      visitorNum: 0,
      dialogForm: {
        id: '',
        realAmount: '',
        adjustDescribe: ''
      },
      rules: {
        realAmount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: /^([1-9]\d{0,9}|0)(\.\d{1,2})?$/,
            message: '请输入有效的的金额'
          }
        ],
        adjustDescribe: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      selectionList: [],
      selectionAmountList: [],
      data: []
    }
  },
  methods: {
    closeDrawer() {
      this.drawer = false
      this.getList(this.handleData())
    },
    openDrawer(row, isConfirm) {
      this.settlementId = row.id
      this.isConfirm = isConfirm
      this.drawer = true
      this.$nextTick(function () {
        this.$refs.detailDrawer.getSettlementDetail()
      })
    },
    saveComfirm() {
      confirmSettlePaid(this.sentData.id)
        .then(res => {
          this.dialogSettlementBillVisible = false
          this.getList(this.handleData())
          this.$message({
            showClose: true,
            message: '确认收款成功',
            type: 'success'
          })
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: '网络故障，请稍后再试',
            type: 'error'
          })
        })
    },
    showSettlementBillDialog(row) {
      this.dialogSettlementBillTitle = '确认收款'
      this.dialogSettlementBillVisible = true
      let data = {
        id: row.id
      }
      this.sentData = data
    },
    showDialog(row) {
      this.dialogTitle = '调整结算价'
      this.dialogUnitPrice = row.amount
      this.dialogType = 'single'
      this.dialogVisible = true
      this.dialogForm.id = row.id
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs['dialogForm'].clearValidate()
      Object.assign(this.$data.dialogForm, this.$options.data().dialogForm)
    },
    handleSettlementBillClose() {
      this.dialogSettlementBillVisible = false
    },
    SelectionChange(val) {
      console.log('val', val)
      this.selectionList = val.map(el => {
        if (el.answerId) {
          return el.answerId
        } else if (el.interviewerId) {
          return el.interviewerId
        }
      })
      let num = 0
      let i = 0
      let selectionVisitorList = []
      this.selectionAmountList = val.map(el => {
        selectionVisitorList.push(el.interviewerId)
        num = num + el.amount
        i++
        return el.amount
      })
      this.sheetAmountSum = num
      this.sheetNum = i
      this.visitorNum = [...new Set(selectionVisitorList)].length
      console.log('this.selectionList', this.selectionList)
    },
    // 结算单调价
    editMoney() {
      this.$refs['dialogForm'].validate(valid => {
        if (valid) {
          this.dialogForm.settleType = this.settleType
          settlementAdjust(this.dialogForm)
            .then(res => {
              this.dialogVisible = false
              Object.assign(this.$data.dialogForm, this.$options.data().dialogForm)
              this.getList(this.handleData())
              this.$message({
                showClose: true,
                message: '结算单调价成功',
                type: 'success'
              })
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: '结算单调价失败',
                type: 'error'
              })
            })
        } else {
          return false
        }
      })
    },
    getList(params) {
      getList.call(this, params)
    },
    // 整理请求数据
    handleData() {
      const fs = deepClone(this.forms)
      fs.current = this.page.currentPage
      fs.size = this.page.pageSize
      fs.surveyId = GlobalConfig.getSurveyId()
      fs.settleType = this.settleType
      fs.isExecutor = true
      return fs
    },
    commonChange() {
      this.getList(this.handleData())
    },
    onChangeSearchField(params) {
      this.forms = params
      this.page.currentPage = 1
      this.getList(this.handleData())
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      //   重新渲染
      this.getList(this.handleData())
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      //   重新渲染
      this.getList(this.handleData())
    },
    init() {
      this.page = {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      }
      this.commonChange()
    }
  },
  created() {
    this.surveyId = GlobalConfig.getSurveyId()
    this.init()
  }
}
